export default {
      id: "Icon--more-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--more",
      toString: function () {
        return this.url;
      }
    }